import {EventType, EventKind, buildEventCreator, overrideKeys} from 'services/analytics';

export const converter = overrideKeys<UserSpentMoneyEventPayload>({
  daysLeft: 'days_left',
  initialBudget: 'budget_total',
  initialPeriod: 'period_exact',
  spentAtLastDay: 'spend_last_day',
});

export const name = EventKind.UserSpentEverything;
export const createEvent = buildEventCreator<EventType.Detailed, UserSpentMoneyEventPayload>({
  name,
  converter,
});
